import React from 'react';
import { useNavigate } from 'react-router-dom';
import useScrollAnimation from '../../hooks/useScrollAnimation';
import './ProgramDetail.css';

const ComputerTrainingClass = () => {
    useScrollAnimation();
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate('/programs/technology');
    };

    return (
        <div className="program-detail-page">
            <div className="program-hero">
                <div className="container">
                    <button onClick={handleBackClick} className="back-link">
                        <i className="fas fa-arrow-left"></i> Back to Technology Program
                    </button>
                    <div className="program-hero-content">
                        <div className="program-icon-hero">
                            <i className="fas fa-chalkboard-teacher"></i> 
                        </div>
                        <h1>Computer Training Class</h1>
                        <p className="program-tagline">Comprehensive computer education for career advancement</p>
                    </div>
                </div>
            </div>

            <div className="program-content">
                <div className="container">
                    <section className="program-section scroll-animate">
                        <h2>About Computer Training Class</h2>
                        <p>Our Computer Training Classes offer comprehensive, structured computer education programs designed to prepare rural youth for employment in the digital economy. These classes run year-round at our dedicated training centers.</p>
                        <p>We provide in-depth training on essential software, typing skills, internet usage, and professional development. Our goal is to make our students job-ready with industry-relevant computer skills.</p>
                    </section>

                    <section className="program-section scroll-animate">
                        <h2>Key Statistics</h2>
                        <div className="achievements-grid">
                            <div className="achievement-card">
                                <div className="achievement-number">700+</div>
                                <div className="achievement-label">Students Trained</div>
                                <p>Successfully completed our programs</p>
                            </div>
                            <div className="achievement-card">
                                <div className="achievement-number">95%</div>
                                <div className="achievement-label">Completion Rate</div>
                                <p>Students finishing full course</p>
                            </div>
                            <div className="achievement-card">
                                <div className="achievement-number">6-7</div>
                                <div className="achievement-label">Months Duration</div>
                                <p>Comprehensive training period</p>
                            </div>
                        </div>
                    </section>

                    <section className="program-section scroll-animate">
                        <h2>Courses Offered</h2>
                        <div className="features-list">
                            <div className="feature-item">
                                <i className="fas fa-check-circle"></i>
                                <div>
                                    <h3>MS Office Suite</h3>
                                    <p>Comprehensive training in Word, Excel, PowerPoint, and Outlook</p>
                                </div>
                            </div>
                            <div className="feature-item">
                                <i className="fas fa-check-circle"></i>
                                <div>
                                    <h3>Computer Fundamentals</h3>
                                    <p>Operating systems, file management, software installation</p>
                                </div>
                            </div>
                            <div className="feature-item">
                                <i className="fas fa-check-circle"></i>
                                <div>
                                    <h3>Typing Skills</h3>
                                    <p>Touch typing training with speed and accuracy development</p>
                                </div>
                            </div>
                            <div className="feature-item">
                                <i className="fas fa-check-circle"></i>
                                <div>
                                    <h3>Internet & Email</h3>
                                    <p>Web navigation, email etiquette, online collaboration tools</p>
                                </div>
                            </div>
                            <div className="feature-item">
                                <i className="fas fa-check-circle"></i>
                                <div>
                                    <h3>Digital Literacy</h3>
                                    <p>Cybersecurity, social media, digital citizenship, and online safety</p>
                                </div>
                            </div>
                            <div className="feature-item">
                                <i className="fas fa-check-circle"></i>
                                <div>
                                    <h3>Career Preparation</h3>
                                    <p>Resume writing, job applications, interview skills, professional communication</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="program-section scroll-animate">
                        <h2>Course Structure</h2>
                        <div className="activities-timeline">
                            <div className="activity">
                                <div className="activity-day">Level 1</div>
                                <div className="activity-content">
                                    <h3>Foundation (2 Months)</h3>
                                    <p>Computer basics, Windows OS, typing practice, and internet fundamentals</p>
                                </div>
                            </div>
                            <div className="activity">
                                <div className="activity-day">Level 2</div>
                                <div className="activity-content">
                                    <h3>Intermediate (3 Months)</h3>
                                    <p>MS Word, Excel basics, PowerPoint, email communication, and online tools</p>
                                </div>
                            </div>
                            <div className="activity">
                                <div className="activity-day">Level 3</div>
                                <div className="activity-content">
                                    <h3>Advanced (2 Months)</h3>
                                    <p>Advanced Excel, professional presentations, career prep, and exam preparation</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="program-section scroll-animate">
                        <h2>Training Facilities</h2>
                        <div className="menu-grid">
                            <div className="menu-item">
                                <h3>Modern Computer Lab</h3>
                                <p>50+ computers with latest software</p>
                            </div>
                            <div className="menu-item">
                                <h3>High-Speed Internet</h3>
                                <p>Reliable connectivity for all students</p>
                            </div>
                            <div className="menu-item">
                                <h3>Experienced Instructors</h3>
                                <p>Qualified trainers with industry experience</p>
                            </div>
                            <div className="menu-item">
                                <h3>Free Certification</h3>
                                <p>Course completion certificates provided</p>
                            </div>
                            <div className="menu-item">
                                <h3>Study Materials</h3>
                                <p>Books, practice sheets, and online resources</p>
                            </div>
                            <div className="menu-item">
                                <h3>Air-Conditioned Rooms</h3>
                                <p>Comfortable learning environment</p>
                            </div>
                        </div>
                    </section>

                    <section className="program-section scroll-animate">
                        <h2>Program Impact</h2>
                        <div className="impact-stats">
                            <div className="impact-item">
                                <i className="fas fa-briefcase"></i>
                                <h3>Better Employment</h3>
                                <p>Students getting jobs in offices, banks, and IT companies</p>
                            </div>
                            <div className="impact-item">
                                <i className="fas fa-chart-line"></i>
                                <h3>Increased Confidence</h3>
                                <p>Youth confident to compete in urban job markets</p>
                            </div>
                            <div className="impact-item">
                                <i className="fas fa-graduation-cap"></i>
                                <h3>Continued Learning</h3>
                                <p>Students pursuing advanced certifications and courses</p>
                            </div>
                        </div>
                    </section>

                    <section className="program-section scroll-animate">
                        <h2>Class Schedule</h2>
                        <div className="beneficiaries-info">
                            <p><strong>Morning Batch:</strong> 9:00 AM - 12:00 PM (Monday to Saturday)</p>
                            <p><strong>Afternoon Batch:</strong> 2:00 PM - 5:00 PM (Monday to Saturday)</p>
                            <p><strong>Evening Batch:</strong> 5:30 PM - 8:30 PM (Monday to Friday)</p>
                            <p>Classes are conducted in small batches (15-20 students) to ensure personalized attention. Both Tamil and English medium options available.</p>
                        </div>
                    </section>

                    <section className="program-section scroll-animate">
                        <h2>Student Success Stories</h2>
                        <div className="success-stories">
                            <div className="story-card">
                                <i className="fas fa-quote-left"></i>
                                <p>"I completed the computer training and immediately got a job at a local bank as a clerk. The course changed my life!"</p>
                                <div className="story-author">- Priya, 22, Bank Clerk</div>
                            </div>
                            <div className="story-card">
                                <i className="fas fa-quote-left"></i>
                                <p>"The Excel skills I learned here helped me become an accountant. I highly recommend this program to all rural youth."</p>
                                <div className="story-author">- Ravi, 25, Accountant</div>
                            </div>
                            <div className="story-card">
                                <i className="fas fa-quote-left"></i>
                                <p>"Now I can confidently apply for any government job that requires computer knowledge. Thank you for the free training!"</p>
                                <div className="story-author">- Lakshmi, 24, Job Aspirant</div>
                            </div>
                        </div>
                    </section>

                    <section className="program-section scroll-animate">
                        <h2>Admission Process</h2>
                        <div className="beneficiaries-info">
                            <p><strong>Eligibility:</strong> Anyone above 15 years who can read and write Tamil or English</p>
                            <p><strong>Fee:</strong> Completely FREE - no charges for training, materials, or certification</p>
                            <p><strong>Documents Required:</strong> Aadhar card, one passport photo, and school leaving certificate (if applicable)</p>
                            <p><strong>How to Apply:</strong> Visit our training center or contact us to register for the next batch</p>
                        </div>
                    </section>

                    <section className="program-cta scroll-animate">
                        <h2>Support Computer Training Classes</h2>
                        <p>Help us train more rural youth and improve their employability</p>
                        <div className="cta-buttons">
                            <button onClick={() => navigate('/donate')} className="btn btn-primary btn-large">Donate Now</button>
                            <button onClick={() => navigate('/contact')} className="btn btn-secondary btn-large">Enroll Now</button>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default ComputerTrainingClass;
